/* ------------------------------------------------
** 主Menu
--------------------------------------------------*/
$(function () {
    // 配置项
    var config = {
        animationSpeed: 300, // 动画持续时间
        responsiveThreshold: 992 // 响应式阈值，窗口宽度大于此值时才启用 hover 效果
    };

    // 当前窗口宽度
    var winwidth = $(window).width();

    // 动态更新窗口宽度
    $(window).on("resize", function () {
        winwidth = $(window).width();
    });

    // 防抖处理：避免快速移动鼠标触发多次 hover
    let hoverTimer;

    // 主菜单 hover 逻辑
    $(".main-menu > ul > li").hover(
        function () {
            clearTimeout(hoverTimer); // 清除离开时的延迟
            // PC版时
            if (winwidth > config.responsiveThreshold) {
                var subMenu = $(this).children(".sub"); // 缓存子菜单选择器
                hoverTimer = setTimeout(() => {
                    if (!subMenu.is(":visible")) {
                        subMenu.stop(true, true).slideDown(config.animationSpeed).parent().siblings().children(".sub").slideUp(config.animationSpeed); // 显示子菜单
                    }
                }, 100); // 延迟 100ms
            }
        },
        function () {
            clearTimeout(hoverTimer); // 清除进入时的延迟
            // 手机版时
            if (winwidth > config.responsiveThreshold) {
                var subMenu = $(this).children(".sub"); // 缓存子菜单选择器
                hoverTimer = setTimeout(() => {
                    subMenu.stop(true, true).slideUp(config.animationSpeed); // 隐藏子菜单
                }, 100); // 延迟 100ms
            }
        }
    );

    // 手机版点击togglemenu触发事件
    $(".toggle-menu").click(function () {
        $(".main-menu").slideToggle();
        $(this).toggleClass("active");
    });

    // 手机版点击右侧图标展开事件
    $(".main-menu>ul>li>.down").click(function (e) {
        var winwidth = $(window).width();
        if (winwidth < config.responsiveThreshold) {
            $(this).siblings(".sub").slideToggle().parent().toggleClass("open").siblings().removeClass("open").children(".sub").slideUp();
            e.preventDefault();
            return false;
        }
    });

    // 解决当链接存在平滑滚动时在当前页面menu不能上滑的问题
    $(".main-menu a").click(function () {
        if (winwidth > config.responsiveThreshold) {
            console.log(`处理PC时的上滑问题`);
            $(".main-menu .sub").slideUp();
        }
        else {
            console.log(`处理手机版的上滑问题`);
            $(".main-menu").slideUp();
            $("#togglemenu").removeClass("active");
        }
    })
})